<!-- Clinic Home Component -->
<div class="header-section">
  <div class="header-content">
    <div class="header-left">
      <h1 class="page-title">
        <i class="pi pi-building"></i>
        Clinic Products
      </h1>
      <p class="page-subtitle">
        Browse and order products for your assigned clinics
      </p>
    </div>
  </div>
</div>

<!-- if clinic length is 0 show no products have a piece of text that shows they need to be assinged to a clinic -->
<div
  *ngIf="clinicCount === 0 && !loadingPage"
  class="no-clinic-container"
>
  <div class="no-clinic-content">
    <i class="pi pi-exclamation-triangle no-clinic-icon"></i>
    <h3 class="no-clinic-title">No Clinics Assigned</h3>
    <p class="no-clinic-text">
      You are not assigned to any clinics. Please contact your administrator
      to get access.
    </p>
  </div>

</div>


<!-- Search Section -->
<div class="search-section" *ngIf="clinicCount > 0">
  <div class="search-container">
    <span class="p-input-icon-left">
      <i class="pi pi-search"></i>
      <input
        type="text"
        pInputText
        placeholder="Search..."
        [(ngModel)]="searchTerm"
        (ngModelChange)="searchTermChanged.next($event)"
        class="search-input"
      />
    </span>
  </div>
</div>

<div class="clinic-home-container">

  <!-- Toast Notifications -->
  <p-toast key="main"></p-toast>

  <!-- Loading State -->
  <div *ngIf="loadingPage" class="loading-container">
    <div class="loading-content">
      <p-progressSpinner
        strokeWidth="3"
        animationDuration=".5s"
      ></p-progressSpinner>
      <p class="loading-text">Loading clinic products...</p>
    </div>
  </div>

  <!-- Main Content -->
  <div *ngIf="!loadingPage && clinicCount > 0" class="main-content">

    <!-- Clinic Selection Section -->
    <div class="clinic-selection-section" *ngIf="clinicCount > 1">
      <div class="selection-card">
        <div class="card-header">
          <h3 class="card-title">
            <i class="pi pi-hospital"></i>
            Select Clinic
          </h3>
          <p class="card-subtitle">
            Choose a clinic to view available products
          </p>
        </div>
        <div class="card-content">
          <p-dropdown
            [options]="clinics"
            [(ngModel)]="selectedClinic"
            optionLabel="name"
            placeholder="Select a Clinic"
            class="clinic-dropdown"
            (onChange)="onClinicChange()"
            appendTo=""
          ></p-dropdown>
          <div *ngIf="errorMessage" class="error-message">
            <i class="pi pi-exclamation-triangle"></i>
            {{ errorMessage }}
          </div>
        </div>
      </div>
    </div>

    <!-- Current Clinic Display -->
    <div class="current-clinic-section" *ngIf="selectedClinic">
      <div class="clinic-info-card">
        <div class="clinic-info">
          <div class="clinic-icon">
            <i class="pi pi-building"></i>
          </div>
          <div class="clinic-details">
            <h3 class="clinic-name">{{ selectedClinic.name }}</h3>
            <p class="clinic-subtitle">Currently ordering for this clinic</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Products Grid -->
    <div class="products-section">
      <div class="products-grid" *ngIf="clinicProducts.length > 0">
        <div *ngFor="let product of clinicProducts" class="product-card">
          <div class="product-image">
            <img
              [src]="
                product.image_url
              "
              [alt]="product.name"
              class="product-img"
            />
            <div class="product-overlay">
              <button
                pButton
                pRipple
                icon="pi pi-eye"
                class="p-button-rounded p-button-text"
                (click)="viewProduct(product)"
                pTooltip="View details"
              ></button>
            </div>
          </div>

          <div class="product-content">
            <div class="product-header">
              <h4 class="product-name">{{ product.name }}</h4>
              <span class="product-size">Size: {{ product.size }}</span>
            </div>

            <p class="product-description">{{ product.description }}</p>

            <div class="product-meta">
              <div class="product-price">
                <span class="price-label">Price:</span>
                <span class="price-value">{{
                  product.cost_excl_vat | currency : "R"
                }}</span>
              </div>
              <div class="product-pack">
                <span class="pack-label">Pack:</span>
                <span class="pack-value">{{
                  product.quantity 
                }}</span>
              </div>
            </div>

            <div class="product-actions">
              <div class="quantity-selector">
                <label class="quantity-label">Quantity:</label>
                <p-dropdown
                  [options]="quantityOptions"
                  [(ngModel)]="product.selectedQuantity"
                  placeholder="Select Quantity"
                  class="quantity-dropdown"
                  appendTo="body"
                  [class.quantity-error]="product.showQuantityError"
                  (onChange)="onQuantityChange(product)"
                  [disabled]="product.disableQuantityDropdown"
                ></p-dropdown>
                <div *ngIf="product.showQuantityError" class="quantity-error-message">
                  <i class="pi pi-exclamation-triangle"></i>
                  Please select a quantity
                </div>
              </div>

              <div class="action-buttons">
                <button
                  pButton
                  pRipple
                  label="Add to Cart"
                  icon="pi pi-shopping-cart"
                  class="p-button-primary"
                  (click)="addProductToCart(product)"
                  [loading]="loadingPage"
                ></button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div
        *ngIf="clinicProducts.length === 0 && !loadingPage"
        class="empty-state"
      >
        <div class="empty-content">
          <i class="pi pi-box empty-icon"></i>
          <h3 class="empty-title">No Products Found</h3>
          <p class="empty-text">
            No products match your search criteria or are available for the
            selected clinic.
          </p>
          <button
            pButton
            pRipple
            label="Refresh Products"
            icon="pi pi-refresh"
            class="p-button-outlined"
            (click)="refreshProducts()"
          ></button>
        </div>
      </div>
    </div>
  </div>
</div>
